let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kRYgy")).then(() => parcelRequire('dPfCM'));